import { render, staticRenderFns } from "./DocsList.vue?vue&type=template&id=60c06b6f&scoped=true&"
import script from "./DocsList.vue?vue&type=script&lang=js&"
export * from "./DocsList.vue?vue&type=script&lang=js&"
import style0 from "./DocsList.vue?vue&type=style&index=0&id=60c06b6f&lang=scss&scoped=true&"
import style1 from "./DocsList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./DocsList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c06b6f",
  null
  
)

export default component.exports